import * as React from 'react'

import { CheckIcon } from 'lucide-react'
import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'
import { AutoSizer, List } from 'react-virtualized'

import ProjectDateStore from '../../../stores/ui/ProjectDate.store'
import { YEARS_BACK, YEARS_FORWARD } from '../CommonDateFilter.constants'

import './YearPicker.scss'

interface IProps {
  selectedYear: number
  onYearSelect: (year: number) => void
  projectDateStore: ProjectDateStore
}

const TOTAL_YEARS = YEARS_BACK + YEARS_FORWARD + 1
const ROW_HEIGHT = 44

@observer
export default class YearPicker extends React.Component<IProps> {
  private readonly baseYear: number

  public constructor(props: IProps) {
    super(props)

    const currentYear = new Date().getFullYear()
    this.baseYear = currentYear - YEARS_BACK
  }

  public render() {
    const scrollToIndex = this.getInitialScrollIndex()

    return (
      <div className="year-picker">
        <AutoSizer>
          {({ width, height }) => (
            <List
              width={width}
              height={height}
              rowCount={TOTAL_YEARS}
              rowHeight={ROW_HEIGHT}
              rowRenderer={this.renderYearRow}
              scrollToIndex={scrollToIndex}
              scrollToAlignment="center"
            />
          )}
        </AutoSizer>
      </div>
    )
  }

  private getInitialScrollIndex(): number {
    const { selectedYear } = this.props
    return selectedYear - this.baseYear
  }

  private renderYearRow = ({
    index,
    key,
    style,
  }: {
    index: number
    key: string
    style: React.CSSProperties
  }): JSX.Element => {
    const { selectedYear, onYearSelect } = this.props
    const year = this.baseYear + index
    const isSelected = year === selectedYear
    const isCurrentYear = year === new Date().getFullYear()

    return (
      <div
        key={key}
        style={style}
        className={classList({
          'year-row': true,
          selected: isSelected,
          'current-year': isCurrentYear,
        })}
        onClick={() => onYearSelect(year)}
      >
        <span className="year-label">{year}</span>
        {isSelected && (
          <span className="checkmark">
            <CheckIcon size={18} />
          </span>
        )}
      </div>
    )
  }
}
